/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerRemoveMutationResponse, ExternalProjectLinksControllerRemovePathParams, ExternalProjectLinksControllerRemove401, ExternalProjectLinksControllerRemove403, ExternalProjectLinksControllerRemove404 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerRemove";

function getExternalProjectLinksControllerRemoveUrl(id: ExternalProjectLinksControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/external-project-links/${id}` as const }  
  return res
}

/**
 * @summary Unlink (soft delete) an external project link
 * {@link /api/v1/external-project-links/:id}
 */
export async function externalProjectLinksControllerRemove(id: ExternalProjectLinksControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ExternalProjectLinksControllerRemoveMutationResponse, ResponseErrorConfig<ExternalProjectLinksControllerRemove401 | ExternalProjectLinksControllerRemove403 | ExternalProjectLinksControllerRemove404>, unknown>({ method : "DELETE", url : getExternalProjectLinksControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}